var map = {
	"./auth/service": "c22e",
	"./azmoon/service": "f419",
	"./cooperation/service": "dfcc",
	"./fileManagement/service": "672a",
	"./home/service": "31a1",
	"./interview/service": "cc4e",
	"./kanoon/service": "7039",
	"./profile/service": "e827",
	"./report/service": "1048",
	"./research/service": "0f86",
	"./survey/service": "1c59",
	"./task/service": "f405",
	"./ticket/service": "f1ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cef8";